export const orderIns = [
  {
    path: '/order-ins',
    name: 'OrderIns',
    component: () =>
      import(
        '@/views/orderIns'
      ),
    meta: {
      title: ''
    }
  },
  {
    path: '/order-success',
    name: 'OrderSuccess',
    component: () =>
      import(
        '@/views/orderIns/orderSuccess'
      ),
    meta: {
      title: ''
    }
  },
]